<template>
  <v-img
    :alt="alt"
    :aspect-ratio="aspectRatio"
    :contain="contain"
    :content-class="contentClass"
    :dark="dark"
    :eager="eager"
    :gradient="gradient"
    :height="height"
    :lazy-src="lazySrc"
    :light="light"
    :max-height="maxHeight"
    :max-width="maxWidth"
    :min-height="minHeight"
    :min-width="minWidth"
    :options="options"
    :position="position"
    :sizes="sizes"
    :src="srcVal"
    :srcset="srcSet"
    :transition="transition"
    :width="width"
    @click="event => $emit('onClick', event)"
    @error="event => $emit('onError', event)"
  >
    <template #placeholder>
      <slot name="placeholder" />
    </template>
    <template #default>
      <slot name="default" />
    </template>
  </v-img>
</template>

<script>
export default {
  name: 'ImageField',

  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    alt: {
      type: String,
      default: undefined
    },
    aspectRatio: {
      type: [String, Number],
      default: undefined
    },
    contain: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: String,
      default: undefined
    },
    dark: {
      type: Boolean,
      default: false
    },
    eager: {
      type: Boolean,
      default: false
    },
    gradient: {
      type: String,
      default: undefined
    },
    height: {
      type: [Number, String],
      default: undefined
    },
    lazySrc: {
      type: String,
      default: undefined
    },
    light: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: [Number, String],
      default: undefined
    },
    maxWidth: {
      type: [Number, String],
      default: undefined
    },
    minHeight: {
      type: [Number, String],
      default: undefined
    },
    minWidth: {
      type: [Number, String],
      default: undefined
    },
    options: {
      type: Object,
      default: () => ({})
    },
    position: {
      type: String,
      default: 'center center'
    },
    sizes: {
      type: String,
      default: undefined
    },
    src: {
      type: [String, Object, Function],
      default: undefined
    },
    srcSet: {
      type: String,
      default: undefined
    },
    transition: {
      type: [Boolean, String],
      default: 'fade-transition'
    },
    width: {
      type: [Number, String],
      default: undefined
    }
  },

  emits: [
    'onClick',
    'onError'
  ],

  data () {
    return {
      srcVal: undefined
    }
  },

  watch: {
    src: {
      immediate: true,
      deep: true,
      async handler (val) {
        if (typeof val === 'function') {
          this.srcVal = await val()
        }
        else {
          this.srcVal = val
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
